import { Button } from "./button";

export function PrimaryButton(props: React.ComponentProps<typeof Button>) {
  return <Button variant="default" {...props} />;
}
